import BRAND from './brand';
import type { Service, Feature, ProcessStep, Testimonial, FeatureSlide, Location } from './types';
import {
  SparklesIcon, SparklesSolidIcon, HomeIcon, BuildingOfficeIcon, TruckIcon,
  MovingBoxIcon, ShieldCheckIcon, ThumbUpIcon, UsersIcon,
  PhoneArrowUpRightIcon, CalendarDaysIcon, CheckBadgeIcon,
  HeartIcon, LockClosedIcon, CheckCircleIcon
} from './components/IconComponents';

// FIX: Added BUSINESS_HOURS constant required by CalendarBooking component.
export const BUSINESS_HOURS = {
  start: 9, // 9 AM
  end: 17, // 5 PM
};

// FIX: Added MOCKED_BOOKED_SLOTS constant required by CalendarBooking component.
export const MOCKED_BOOKED_SLOTS = new Set<string>([
  // Example: 'YYYY-MM-DD-HH'
]);

export const SERVICES: Service[] = [
  {
    icon: SparklesSolidIcon,
    title: 'Classic Manicure',
    description: 'Shape, cuticle care, hand massage, and a flawless polish finish.',
    duration: 30,
    reservationFee: 5,
  },
  {
    icon: CheckBadgeIcon,
    title: 'Gel Manicure',
    description: 'Chip-resistant gel color cured to a glossy finish that lasts 2-3 weeks.',
    duration: 45,
    reservationFee: 10,
  },
  {
    icon: HeartIcon,
    title: 'Spa Pedicure',
    description: 'Soak, exfoliation, callus care, massage, and polish — pure relaxation.',
    duration: 50,
    reservationFee: 10,
  },
  {
    icon: UsersIcon,
    title: 'Dip Powder Full Set',
    description: 'Lightweight, durable dip powder color with a natural look — no UV needed.',
    duration: 60,
    reservationFee: 15,
  },
];

export const FEATURE_SLIDES: FeatureSlide[] = [
  {
    image: '/images/hero.svg',
    video: '',
    title: `The ${BRAND.shortName} Touch`,
    subtitle: 'Every Set, Every Season',
    description: 'Meticulous manicures, spa pedicures, and dip or gel sets done with clean tools and a steady hand. You leave with nails you cannot stop looking at.',
    features: [
      { icon: CheckBadgeIcon, text: 'Licensed, Experienced Nail Techs' },
      { icon: SparklesIcon, text: 'Hospital-Grade Sanitized Tools' },
      { icon: HeartIcon, text: 'Relaxing, Unhurried Service' },
    ],
  },
  {
    image: '/images/hero.svg',
    video: '',
    title: 'Your Seat Is Ready When You Are',
    subtitle: 'Book Online, Skip The Wait',
    description: 'Pick your service, pick your time, lock it with a small deposit. No sitting around the salon — your tech is ready the minute you walk in.',
    features: [
      { icon: CalendarDaysIcon, text: 'Real-Time Online Booking' },
      { icon: LockClosedIcon, text: 'Small Deposit Holds Your Spot' },
      { icon: PhoneArrowUpRightIcon, text: 'Text Reminders Before Your Visit' },
    ],
  },
  {
    image: '/images/hero.svg',
    video: '',
    title: 'Walk-Ins Still Welcome',
    subtitle: 'Salon-Quality Care, Zero Hassle',
    description: 'Booking gets you priority, but the door is always open. Stop by, put your name in, and we will get you to the next open seat.',
    features: [
      { icon: UsersIcon, text: 'Groups & Special Occasions' },
      { icon: ThumbUpIcon, text: 'Straightforward Prices' },
      { icon: CheckCircleIcon, text: 'Satisfaction Guaranteed' },
    ],
  },
];


export const HOW_IT_WORKS_STEPS: ProcessStep[] = [
  {
    icon: PhoneArrowUpRightIcon,
    title: '1. Pick Your Service',
    description: 'Manicure, gel, spa pedicure, or a full dip set — choose what you need and see the price up front. No surprises at checkout.',
  },
  {
    icon: CalendarDaysIcon,
    title: '2. Lock In Your Time',
    description: 'Choose a day and time that works. A small deposit holds your seat — it comes off your total when you pay.',
  },
  {
    icon: CheckBadgeIcon,
    title: '3. Sit Back & Get Pampered',
    description: 'Your nail tech is ready when you arrive. Fresh set, perfect polish, zero waiting — out the door feeling brand new.',
  },
];

export const TESTIMONIALS: Testimonial[] = [
  { quote: "My gel mani still looked perfect after three weeks. Best in Manalapan, easily.", author: 'Jessica', role: 'Regular', rating: 5 },
  { quote: 'They fit my daughter and me in together before prom — nails came out gorgeous.', author: 'Maria', role: 'Client', rating: 5 },
  { quote: 'Spotless salon, sanitized tools, and the pedicure massage is unreal.', author: 'Dana', role: 'Regular', rating: 5 },
  { quote: 'Booking online with a small deposit means my seat is actually ready when I arrive.', author: 'Priya', role: 'Client', rating: 5 },
];
export const LOCATIONS: Location[] = [
  {
    state: BRAND.serviceArea,
    cities: [],
    image: '/images/hero.svg',
  },
];

